import axios, { AxiosError, AxiosResponse } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { BoltOnItem } from '../components/ui/input/DropdownInput';
import { LoadBoltOnsPayload } from '../models/payload/loadRequests';
import { BoltOn } from '../models/transfer/input/BoltOn';
import config from '../config';
const log = getLogger('simManagement.api.simProvisionApi');

export function getBoltOnsById(boltOns: number[]): Promise<BoltOnItem[]> {
  const boltOnNumbers = boltOns.map((nbr) => `boltOnNumbers=${nbr}`);
  const boltOnNumbersText = (boltOnNumbers.length > 0 ? '?' : '') + boltOnNumbers.join('&');
  return new Promise<BoltOnItem[]>((resolve, reject) => {
    axios
      .get(`${config.API_BASE_URL}api/bolton/${boltOnNumbersText}`)
      .then((response: AxiosResponse<{ result: BoltOn[] }>) => {
        const dropDownItems: BoltOnItem[] = response.data.result.map((b: any) => {
          return {
            key: b.number,
            label: b.name,
            isTemporal: b.isTemporal,
            isDataBoltOn: b.isDataBoltOn,
            isLegacy: b.isLegacy,
          };
        });

        resolve(dropDownItems);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to load bolt-ons.', simManagementError);
        reject(simManagementError);
      });
  });
}

export function getBoltOns(payload: LoadBoltOnsPayload): Promise<BoltOnItem[]> {
  const { accountId, boltOns, tariffNumber, isTemporal } = payload;

  const boltOnNumbersParams = boltOns
    .split(',')
    .map((nbr) => nbr.trim())
    .filter((nbr) => nbr !== '')
    .map((nbr) => `boltOnNumbers=${nbr}`);

  const queryParams = [`isTemporal=${isTemporal}`];
  if (boltOnNumbersParams.length > 0) {
    queryParams.push(...boltOnNumbersParams);
  }

  return new Promise<BoltOnItem[]>((resolve, reject) => {
    axios
      .get(`${config.API_BASE_URL}api/account/${accountId}/tariff/${tariffNumber}/boltOns/?${queryParams.join('&')}`)
      .then(
        (
          response: AxiosResponse<{
            count: number;
            totalCount?: number;
            result: BoltOn[];
          }>,
        ) => {
          const dropDownItems: BoltOnItem[] = response.data.result.map((b: any) => {
            return {
              key: b.number,
              label: b.name,
              isTemporal: b.isTemporal,
              isDataBoltOn: b.isDataBoltOn,
              isLegacy: b.isLegacy,
              domesticVoice: b.domesticVoice,
              internationalVoice: b.internationalVoice,
              fixedIp: b.fixedIp,
              publicIp: b.publicIp
            };
          });

          resolve(dropDownItems);
        },
      )
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to load bolt-ons.', simManagementError);
        reject(simManagementError);
      });
  });
}
